export default "__VITE_ASSET__Bd7KzAF2__"